// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hKzqd{font-family:"Inter",sans-serif;font-size:11px !important}
.TSXxk{font-family:"Inter",sans-serif;font-size:14px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepIndicator": `hKzqd`,
	"stepLabel": `TSXxk`
};
module.exports = ___CSS_LOADER_EXPORT___;
